import { getDate, startOfDay, endOfDay } from 'date-fns'
import { MainContainer, Number } from './DaysStyles'

interface DateRange {
  startDate: Date | null
  endDate: Date | null
}

interface DaysProps {
  fullDate: Date
  isOnCurrentMonth: boolean
  dateRange: DateRange
  setDateRange: React.Dispatch<React.SetStateAction<DateRange>>
}

function Days({
  isOnCurrentMonth,
  dateRange,
  fullDate,
  setDateRange,
}: DaysProps) {
  // Verificar se as datas de início e término são válidas
  const startDateIsValid = dateRange.startDate !== null
  const endDateIsValid = dateRange.endDate !== null

  const handleSelectDate = () => {
    if (!isOnCurrentMonth) return

    // Nenhuma data selecionada: define startDate
    if (!startDateIsValid && !endDateIsValid) {
      setDateRange({ startDate: fullDate, endDate: null })
      return
    }

    // Só startDate está selecionada
    if (startDateIsValid && !endDateIsValid) {
      if (fullDate.getTime() < dateRange.startDate!.getTime()) {
        // Se clicar numa data antes da startDate, redefine startDate
        setDateRange({ startDate: fullDate, endDate: null })
      } else if (fullDate.getTime() === dateRange.startDate!.getTime()) {
        // Se clicar na mesma startDate, limpa seleção (opcional)
        setDateRange({ startDate: null, endDate: null })
      } else {
        // Se clicar depois da startDate, define endDate
        setDateRange((prev) => ({ ...prev, endDate: fullDate }))
      }
      return
    }

    // Se já tem startDate e endDate, reseta o intervalo para começar novo
    setDateRange({ startDate: fullDate, endDate: null })
  }

  const isInRange = (): boolean => {
    const normalizedDate = startOfDay(fullDate)

    if (dateRange.startDate && !dateRange.endDate) {
      return (
        normalizedDate.getTime() === startOfDay(dateRange.startDate).getTime()
      )
    }

    if (dateRange.startDate && dateRange.endDate) {
      const start = startOfDay(dateRange.startDate).getTime()
      const end = endOfDay(dateRange.endDate).getTime()
      const current = normalizedDate.getTime()
      return current >= start && current <= end
    }

    return false
  }

  return (
    <MainContainer onClick={handleSelectDate} type="button">
      <Number $isOnCurrentMonth={isOnCurrentMonth} $isInRange={isInRange()}>
        {getDate(fullDate)}
      </Number>
    </MainContainer>
  )
}
export default Days
